/**
 * Supervisor ticket chat should not paint empty-state prompts (or a stale
 * prior ticket's messages) before this ticket's thread has landed in Redux.
 */
export function isTicketConversationReady({
  ticketId,
  loadedTicketId,
  skipInitialize = false,
  loadError = null,
}: {
  ticketId?: string | null;
  loadedTicketId?: unknown;
  skipInitialize?: boolean;
  loadError?: unknown;
}): boolean {
  if (!ticketId || skipInitialize) return true;
  if (loadError) return true;
  return String(loadedTicketId ?? "") === String(ticketId);
}
